<div class="aui-page-panel" style="padding-right: 1px">
  <div class="aui-page-panel-inner">
    <section class="aui-page-panel-content" style="padding-left: 0; padding-right: 0; padding-top: 0">
      <div class="aui-toolbar2">
        <div class="aui-toolbar2-inner">
          <div class="aui-toolbar2-primary">
            <div id="button-set2" class="aui-buttons">
              <!-- <button (click)="reload()">refresh</button> -->
              <app-button
                [iconType]="IconTypes.Configure"
                [id]="'manage-token-btn'"
                [btnTitle]="'Obsidian token'"
                (clickHandler)="goToTokenPage()"
              >
                App settings
              </app-button>
            </div>
          </div>
          <div class="aui-toolbar2-secondary">
            <div class="aui-buttons"></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>

<ng-container *ngIf="loaded; else loadingSpinner">
  <app-issue-details [jiraIssue]="jiraIssue" *ngIf="token?.token"></app-issue-details>
  <div *ngIf="!token?.token" class="p-top-10">
    <app-message [title]="'Obsidian'" [type]="'warning'">
      <p>
        Please set up the connection with Obsidian before using this functionality. Check "App settings" and
        documentation
      </p>
    </app-message>
  </div>
</ng-container>

<ng-template #loadingSpinner>
  <div class="aui-group spinner-center">
    <app-spinner></app-spinner>
  </div>
</ng-template>
